module.exports = __webpack_public_path__ + "staticcomp/img/share.4a08e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/17/share.jpg
// module id = AwyK
// module chunks = 39